const DEFAULT_TEMPLATE = 'This customer receives a {percent}% rebate'

// A rebate line is shown when the customer has a rebate percentage above zero,
// or a custom rebate message. A percentage of 0 (or null) is "no rebate" and
// must not produce a "receives a 0% rebate" line.
export function computeRebateMessageText(customer, globalDefaultMessage) {
  if (!customer) return ''
  if (customer.rebateMessage && String(customer.rebateMessage).trim()) {
    return String(customer.rebateMessage).trim()
  }
  if (typeof customer.rebatePercent === 'number' && !isNaN(customer.rebatePercent) && customer.rebatePercent > 0) {
    const template = (globalDefaultMessage && String(globalDefaultMessage).trim()) || DEFAULT_TEMPLATE
    return template.replace(/\{percent\}/g, customer.rebatePercent)
  }
  return ''
}

export function computeGeneralMessageText(customer) {
  if (!customer) return ''
  return (customer.showMsg && String(customer.showMsg).trim()) || ''
}

export function resolveEffectiveDisplayMode(customer, globalMode) {
  const mode = customer ? customer.msgDisplayMode : null
  if (mode === 2) return 'label'
  if (mode === 3) return 'popup'
  return globalMode === 'popup' ? 'popup' : 'label'
}
